import { Route } from "react-router";
import {
  AcceptSocialLogin,
  ConfirmEmailRedirectFlow,
  Logout,
  RedirectFlow,
  SplashScreen,
} from "@/pages";
import React from "react";

/**
 * Route definitions for general public routes.
 * Includes redirect flows, social login, email confirmation, and logout.
 */
export const generalRoutes: React.ReactElement[] = [
  <Route
    key="redirect-flow-fb"
    path="/r/fb/:customerKey/:email"
    element={<RedirectFlow />}
  />,
  <Route
    key="redirect-flow"
    path="/r/:type/fb/:customerKey/:email"
    element={<RedirectFlow />}
  />,
  <Route
    key="social-login"
    path="/social/login"
    element={<AcceptSocialLogin />}
  />,
  <Route
    key="confirm-email"
    path="/confirm_email/"
    element={<ConfirmEmailRedirectFlow />}
  />,
  <Route key="splash" path="/splash" element={<SplashScreen />} />,
  <Route key="logout" path="/logout" element={<Logout />} />,
];
